var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yx-student-info-detail-page yx-handle-common-page"},[_c('el-card',{staticClass:"box-form"},[_c('c-title',{attrs:{"slot":"header","title":'信息详情'},slot:"header"}),_c('student-info',{attrs:{"id":_vm.id,"jxfFlag":true,"familyFlag":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }